import { render, staticRenderFns } from "./SimpleBarrel.vue?vue&type=template&id=511fb7aa&"
import script from "./SimpleBarrel.vue?vue&type=script&lang=ts&"
export * from "./SimpleBarrel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports